'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _webComponents = require('@vezeeta/web-components');

var _Constants = require('./Constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createFilterSection = function createFilterSection(type, name, filters, placeholder, selectOptions, icon) {
  return _extends({
    type: type,
    name: name,
    filters: filters,
    placeholder: placeholder
  }, selectOptions, {
    icon: icon
  });
};

var createBranchesSection = function createBranchesSection(branches, selectOptions, localizedBranches) {
  var filters = branches.map(function (branch) {
    return {
      data: {
        placeholder: branch.BranchName,
        value: branch.BranchKey,
        searchable: [branch.BranchName]
      },
      component: _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _webComponents.Text,
          null,
          branch.BranchName
        ),
        selectOptions.renderClinicName && _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            _webComponents.Text,
            { className: 'clinic-name' },
            branch.EntityName
          )
        )
      )
    };
  });

  return createFilterSection('combo', _Constants.FILTER_NAMES.BRANCHES, filters, localizedBranches || 'Branches', selectOptions, 'clinic');
};

var createRoomsSection = function createRoomsSection(rooms, selectOptions) {
  var filters = rooms.map(function (room) {
    return {
      id: room.RoomKey,
      label: room.RoomName
    };
  });
  filters.unshift({
    label: 'All rooms',
    isAllCheckbox: true
  });
  return createFilterSection('check', _Constants.FILTER_NAMES.ROOMS, filters, 'Rooms', selectOptions);
};

var createRadioRoomsSection = function createRadioRoomsSection(rooms, selectOptions) {
  var filters = rooms.map(function (room) {
    return {
      name: 'room',
      value: room.RoomKey,
      component: _react2.default.createElement(
        _webComponents.Text,
        null,
        room.RoomName
      )
    };
  });
  return createFilterSection('radio', _Constants.FILTER_NAMES.ROOMS, filters, 'Rooms', selectOptions);
};

var createDoctorsSection = function createDoctorsSection(doctors, selectOptions, localization) {
  var filters = doctors.map(function (doctor) {
    return {
      id: doctor.AccountKey,
      label: doctor.DoctorName
    };
  });
  filters.unshift({
    label: localization && localization.allDoctors || 'All doctors',
    isAllCheckbox: true
  });
  return createFilterSection('check', _Constants.FILTER_NAMES.DOCTORS, filters, localization && localization.doctors || 'Doctors', selectOptions);
};

var createDoctorsSearchSection = function createDoctorsSearchSection(doctors, selectOptions, localizedDoctors) {
  var filters = doctors.map(function (doctor) {
    return {
      data: {
        placeholder: doctor.fieldValue,
        value: doctor.key,
        groupBy: doctor.groupBy,
        groupIcon: doctor.groupIcon,
        searchable: doctor.searchable,
        disabled: doctor.disabled
      },
      component: _react2.default.createElement(
        _webComponents.Text,
        null,
        doctor.fieldValue
      )
    };
  });

  return createFilterSection('combo', _Constants.FILTER_NAMES.DOCTORS, filters, localizedDoctors || 'Doctors', selectOptions, 'user');
};

var filterClinics = function filterClinics(clinics, filterData) {
  return clinics.map(function (clinic) {
    return _extends({}, clinic, {
      Branches: clinic.Branches.filter(function (branch) {
        return !filterData[_Constants.FILTER_NAMES.BRANCHES] || filterData[_Constants.FILTER_NAMES.BRANCHES] === _Constants.ALL_BRANCHES_VALUE || branch.BranchKey === filterData[_Constants.FILTER_NAMES.BRANCHES];
      }).map(function (branch) {
        return _extends({}, branch, {
          Rooms: branch.Rooms.filter(function (room) {
            return !filterData[_Constants.FILTER_NAMES.ROOMS] || filterData[_Constants.FILTER_NAMES.ROOMS].includes(room.RoomKey);
          }).map(function (room) {
            return _extends({}, room, {
              Doctors: room.Doctors.filter(function (doctor) {
                return !filterData.DOCTORS || filterData.DOCTORS.includes(doctor.AccountKey);
              })
            });
          })
        });
      })
    });
  });
};

exports.default = {
  createBranchesSection: createBranchesSection,
  createRoomsSection: createRoomsSection,
  createDoctorsSection: createDoctorsSection,
  createRadioRoomsSection: createRadioRoomsSection,
  filterClinics: filterClinics,
  createDoctorsSearchSection: createDoctorsSearchSection
};
module.exports = exports['default'];